'use client';

import { Box, Button, Link as MuiLink } from '@mui/material';
import Link from 'next/link';
import { FC } from 'react';

import { CallToActionProperties } from './call-to-action.types';

export const CallToAction: FC<CallToActionProperties> = ({
  aemAttributes,
  model,
}) => {
  return (
    <Box {...aemAttributes} data-aue-type="component">
      {model.type === 'button' ? (
        <Button
          data-testid="call-to-action-button"
          disableRipple
          component={Link}
          prefetch={false}
          classes={{ root: model.style }}
          href={model.url || ''}
          target={model.target || '_self'}
        >
          {model.title}
        </Button>
      ) : (
        <MuiLink
          variant="actionRegularRegular"
          data-testid="call-to-action-link"
          component={Link}
          prefetch={false}
          href={model.url || ''}
          target={model.target || '_self'}
          classes={{ root: `${model.style}Text` }}
        >
          {model.title}
        </MuiLink>
      )}
    </Box>
  );
};
